import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './TopNav.module.scss';

const TopNav: React.FC = () => {
  return (
    <header className={styles.header}>
      <div className={`${styles.inner} container`}>
        <NavLink to="/" className={styles.logo}>
          <span>Askevej Flagdage</span>
        </NavLink>
        <nav className={styles.nav} aria-label="Primær navigation">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `${styles.navLink} ${isActive ? styles.active : ''}`
            }
          >
            Forside
          </NavLink>
          <NavLink
            to="/kalender"
            className={({ isActive }) =>
              `${styles.navLink} ${isActive ? styles.active : ''}`
            }
          >
            Kalender
          </NavLink>
          <NavLink
            to="/tilfoej"
            className={({ isActive }) =>
              `${styles.navLink} ${isActive ? styles.active : ''}`
            }
          >
            Tilføj dag
          </NavLink>
          <NavLink
            to="/notifikationer"
            className={({ isActive }) =>
              `${styles.navLink} ${isActive ? styles.active : ''}`
            }
          >
            Notifikationer
          </NavLink>
          <NavLink
            to="/om"
            className={({ isActive }) =>
              `${styles.navLink} ${isActive ? styles.active : ''}`
            }
          >
            Om siden
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default TopNav;
